<template>
  <div class="head">
    <span
      class="back"
      v-if="leftContent === false ? false : true"
      :style="{
        'background-image':
          'url(' +
          (leftContent.icon ? leftContent.icon : leftDefaultIcon) +
          ')',
      }"
      @click="leftBtn"
      v-show="backToggle"
    ></span>
    <template v-if="searchInput">
      <div ref="inputBox" class="searchInput">
        <input
          ref="searchInput"
          type="text"
          placeholder="请输入关键词"
          v-model="searchValue"
        />
        <i class="searchIcon"></i>
        <i class="delValue" v-show="delToggle" @click="delInputValue"></i>
      </div>
    </template>
    {{ searchInput ? "" : title }}
    <span
      class="more"
      v-if="rightContent ? true : false"
      :style="{
        'background-image': rightContent.icon
          ? 'url(' + rightContent.icon + ')'
          : 'none',
      }"
      @click="rightBtn"
      >{{ rightContent.text }}</span
    >
  </div>
</template>

<script>
import { myListener } from "../../util";
import Contents from "@/request/base.default.js";
import { navigate, checkWx } from "@/pages/index/custom";
import { store } from "@/store";

export default {
  props: {
    leftContent: {
      type: [Boolean, Object],
      default: true,
    },
    title: {
      type: String,
      default: "",
    },
    rightContent: {
      type: [Object],
      default: null,
    },
    search: {
      type: [Boolean],
      default: false,
    },
    searchWord: {
      type: [String],
      default: "",
    },
  },
  data() {
    return {
      leftDefaultIcon: require("../assets/img/icon_back.png"),
      searchInput: null,
      backToggle: true,
      delToggle: false,
      searchValue: "",
    };
  },
  methods: {
    leftBtn() {
      if (this.$route.path == "/search") {
        store.dispatch("set_search_word", "");
      }
      let { path } = this.$props.leftContent;
      if (path) {
        this.$router.push(path);
      } else {
        this.$router.go(-1);
      }
    },
    rightBtn() {
      let { rightContent } = this.$props;
      if (rightContent.text) {
        if (this.searchValue) {
          this.$emit("onChange", this.searchValue);
        } else {
          this.$toast("搜索内容不能为空");
        }
      } else {
        if (rightContent.path) {
          this.$router.push(rightContent.path);
        } else if (rightContent.down) {
          if (checkWx()) {
            navigate("", Contents.downURL + "?mini=1");
          } else {
            navigate("", Contents.downURL);
          }
        }
      }
    },
    // 输入框变化
    onchangeInput() {
      let { searchInput } = this.$refs;
      let value = searchInput.value;
      store.dispatch("set_search_word", value);
      if (value) {
        this.delToggle = true;
      } else {
        this.delToggle = false;
      }
    },
    // 清空输入框
    delInputValue() {
      let { searchInput } = this.$refs;
      searchInput.focus();
      this.searchValue = "";
      this.delToggle = false;
    },
  },
  created() {
    this.searchInput = this.$props.search;
    if (this.searchWord) {
      this.searchValue = this.searchWord;
    }
  },
  mounted() {
    let _this = this;
    let { searchInput, inputBox } = this.$refs;
    if (searchInput) {
      this.listen = myListener(searchInput, "blur", function () {
        _this.backToggle = true;
        inputBox.style.left = "50%";
        inputBox.style.marginLeft = "-125px";
        inputBox.style.width = "250px";
      });
      this.listen2 = myListener(searchInput, "focus", function () {
        _this.backToggle = false;
        inputBox.style.left = "20px";
        inputBox.style.marginLeft = "0";
        inputBox.style.width = "295px";
      });
      this.listen3 = myListener(searchInput, "input", function () {
        _this.onchangeInput();
      });
      this.listen4 = myListener(searchInput, "propertychange", function () {
        _this.onchangeInput();
      });
    }
  },
  destroyed() {
    this.listen && this.listen();
    this.listen2 && this.listen2();
    this.listen3 && this.listen3();
    this.listen4 && this.listen4();
  },
};
</script>

<style lang="less" scoped>
.head {
  width: 100%;
  height: 3.75rem;
  line-height: 3.75rem;
  text-align: center;
  position: fixed;
  z-index: 1000;
  background-color: #fff;
  font-size: 18px;
  font-weight: 500;
  color: rgba(34, 34, 34, 1);
  & > span {
    width: 2.5rem;
    height: 1.5rem;
    position: absolute;
    background-size: 1.5rem 1.5rem;
    background-repeat: no-repeat;
    font-size: 14px;
    font-weight: 400;
    color: rgba(34, 34, 34, 1);
    line-height: 1.5rem;
  }
  .back {
    top: 1.125rem;
    left: 1.25rem;
    background-position: center left;
  }
  .more {
    top: 1.125rem;
    right: 1.25rem;
    background-position: center right;
  }
  .searchInput {
    line-height: 2.5rem;
    position: absolute;
    width: 250px;
    height: 2.5rem;
    top: 0.625rem;
    left: 50%;
    margin-left: -125px;
    transition: all 0.7s;
    input {
      width: 100%;
      height: 100%;
      border: none;
      outline: none;
      background-color: #f8f8f8;
      border-radius: 1.25rem;
      font-size: 14px;
      font-weight: 400;
      color: rgba(34, 34, 34, 1);
      box-sizing: border-box;
      padding: 0 2.75rem;
    }
    .searchIcon {
      position: absolute;
      top: 8px;
      left: 12px;
      width: 1.5rem;
      height: 1.5rem;
      background: url("../assets/img/icon_search.png") no-repeat center center;
      background-size: 100% 100%;
    }
    .delValue {
      position: absolute;
      top: 8px;
      right: 12px;
      width: 1.5rem;
      height: 1.5rem;
      background: url("../assets/img/input_del.png") no-repeat center center;
      background-size: 100% 100%;
    }
  }
}
</style>
